import React, { Component } from 'react'
import i18n from '../i18n.json'

class TypeSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedType: this.props.newLogo.userPrefs.selectedType
    }
  }

  onCheckboxClick(evt, selected) {
    evt.preventDefault()
    this.props.updateSelectedType({
      selectedType: selected
    })
    if (selected === 'iconBased' || selected === 'all')
      this.props.stepKeywords()
    else
      this.props.stepLogoPreviews()
  }

  render() {
    let { selectedLanguage } = this.props.newLogo.userPrefs

    return (
      <div className="fullpage">
        <div className="flex-row">
           <div className="page-description">
             <h1>
               { i18n[selectedLanguage]['step-type-title-part1'] }<br />
               <span className="title-cta-green">
              { i18n[selectedLanguage]['step-type-title-cta'] }
               </span><br />
               { i18n[selectedLanguage]['step-type-title-part2'] }
             </h1>
             <p>
               { i18n[selectedLanguage]['step-type-description'] }
             </p>
           </div>
           <div className="page-content">
             <div className="page-content-type">
             <ul className="page-content-list-type">
               <a href={ "/select_type" } onClick={ (evt) => { this.onCheckboxClick(evt, 'typographyBased') } } >
                 <li key={ "default-typecard-type-typography"  }>
                   <label> { i18n[selectedLanguage]['step-type-typography'] } </label>
                   <img src="/logo_examples/typography.png" alt="Typography Based" />
                 </li>
               </a>
               <a href={ "/select_type" } onClick={ (evt) => { this.onCheckboxClick(evt, 'initialsBased') } } >
                 <li key={ "default-typecard-type-initial"  }>
                   <label> { i18n[selectedLanguage]['step-type-initials'] } </label>
                   <img src="/logo_examples/initials.png" alt="Initials Based" />
                 </li>
               </a>
               <a href={ "/select_type" } onClick={ (evt) => { this.onCheckboxClick(evt, 'frameBased') } } >
                 <li key={ "default-typecard-type-frame"  }>
                   <label> { i18n[selectedLanguage]['step-type-frame'] } </label>
                   <img src="/logo_examples/container.png" alt="Container Based" />
                 </li>
               </a>
               <a href={ "/select_type" } onClick={ (evt) => { this.onCheckboxClick(evt, 'iconBased') } } >
                 <li key={ "default-typecard-type-icon"  }>
                  <label> { i18n[selectedLanguage]['step-type-icon'] } </label>
                  <img src="/logo_examples/icon.png" alt="Icon Based" />
                 </li>
               </a>
               <a href={ "/select_type" } onClick={ (evt) => { this.onCheckboxClick(evt, 'all') } } >
                 <li key={ "default-typecard-type-all"  }>
                   <label> { i18n[selectedLanguage]['step-type-all'] } </label>
                   <img src="/logo_examples/all2.png" alt="All Types" />
                 </li>
               </a>
             </ul>
             </div>
           </div>
        </div>
      </div>
    )
  }
}

export default TypeSelector



// WEBPACK FOOTER //
// ./src/components/TypeSelector.js